<template>
  <v-container>
    <v-row>
      <v-col v-if="listaTurnos.length !== 0" class="ma-0 pa-0">
        <v-col class="pt-0">
          <v-card
            flat
            color="background"
            class="d-flex flex-wrap"
          >
            <v-card
              v-for="(medico, m) in getTurnosFiltrados"
              :key="m"
              flat
              outlined
              class="pb-3 mr-1 my-1"
              max-width="350"
              min-width="323"
            >
              <v-card-title
                class="py-1"
                :class="(m % 2 && 'amber') || (!(m % 2) && 'blue')"
              ></v-card-title>
              <v-card-title class="text-break pb-0">{{
                medico.medico.medico
              }}</v-card-title>
              <v-card-subtitle
                class="pt-3 pb-0"
                v-if="medico.medico.especialidad !== ''"
                >{{ medico.medico.especialidad }}</v-card-subtitle
              >
              <template v-for="(turno, k) in medico.turnos">
                <v-row
                  align="center"
                  class="mx-auto pt-2 mt-0"
                  :key="`${k}${medico.medico.idMedico}fecha`"
                >
                  <v-col cols="12" class="pa-0"
                    ><small class="font-weight-medium ml-4 text-capitalize"
                      ><v-icon left small>mdi-calendar</v-icon
                      >{{ turno.weekday }} - {{ turno.fecha }}</small
                    >
                  </v-col>
                  <v-col
                    class="ml-1 pt-0"
                    :key="`${k}${medico.medico.idMedico}turnos`"
                    ><v-chip-group column>
                      <v-chip
                        v-for="(tF, t) in turno.turnos"
                        :key="t"
                        outlined
                        class="green--text text--darken-3"
                        @click="selectTurno(tF)"
                      >
                        {{ tF.hora }}
                      </v-chip>
                    </v-chip-group>
                  </v-col>
                </v-row>
              </template>
            </v-card>
          </v-card>
        </v-col>
      </v-col>
      <v-col class="pt-0" v-else>
        <v-alert
          border="top"
          colored-border
          type="info"
          elevation="2"
          color="black"
          class="telfono"
        >
          Por el momento no tenemos más turnos
          <strong>en línea</strong> disponibles. Por favor pase por la recepción
          del Hospital o llame al
          <strong><a href="tel:0491 418 100">0491 418 100</a></strong>
          para reservar personalmente un turno disponible.
        </v-alert>
      </v-col>
      <v-col
        class="pt-0"
        v-if="!$vuetify.breakpoint.mobile && listaMisTurnos.length !== 0"
        cols="3"
      >
        <v-card flat outlined :to="{ name: 'Mis Turnos' }">
          <v-list three-line dense class="py-0">
            <v-subheader class="ml-2">Turnos reservados</v-subheader>
            <template v-for="(turno, t) in listaMisTurnos">
              <v-list-item :key="t">
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <v-icon small left>mdi-calendar-month</v-icon
                    >{{ turno.turnoMedico.fechaFormated }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-icon small left>mdi-clock</v-icon
                    >{{ turno.turnoMedico.horaFormated }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-icon small left>mdi-account</v-icon
                    >{{ turno.paciente.nombre }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="turno.numeroNotificacion">
                    <v-icon small left>mdi-phone</v-icon
                    >{{ turno.numeroNotificacion }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                    v-else-if="getPacienteTelefono(turno.paciente.idPaciente)"
                  >
                    <v-icon small left>mdi-phone</v-icon
                    >{{ getPacienteTelefono(turno.paciente.idPaciente) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-icon small left>mdi-doctor</v-icon
                    >{{ turno.turnoMedico.medico }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="t < listaMisTurnos.length - 1"
                :key="`t${t}`"
              ></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      :persistent="wait === true ? true : false"
      @click:outside="outsideClick()"
      v-model="reservaDialog"
      max-width="310px"
    >
      <v-card
        min-height="250"
        style="background: #fffffb"
        :class="{ 'red lighten-5': fail, 'green lighten-5': done }"
      >
        <div v-if="!done && !fail && !wait">
          <v-card-title
            ><v-icon color="black" left>mdi-clipboard-check-outline</v-icon
            >Confirmar reserva</v-card-title
          >
          <v-card-text class="pb-0">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-autocomplete
                :autofocus="autofocar"
                ref="paciente"
                v-model="reserva.paciente"
                :items="pacientesPermitidos"
                :rules="commonRules"
                outlined
                label="Paciente"
                auto-select-first
                rounded
                item-text="nombre"
                return-object
                dense
                @change="fillTelefono()"
              >
                <template v-slot:item="{ item }">
                  <small class="black--text font-weight-medium"
                    >{{ item.nombre }}
                    <span v-if="item.celular && item.celular !== ''"
                      >({{ item.celular }})</span
                    ></small
                  >
                </template>
              </v-autocomplete>

              <v-text-field
                v-model="reserva.telefono"
                :rules="commonRules"
                label="Nr. teléfono de notificación"
                outlined
                rounded
                dense
                type="number"
                inputmode="numeric"
              ></v-text-field>

              <div class="text--secondary pb-1">Médico:</div>
              <v-chip outlined>
                <v-icon left> mdi-doctor </v-icon>
                {{ reserva.medico }}
              </v-chip>

              <div class="text--secondary pt-2 pb-1">Fecha y hora:</div>
              <v-chip outlined>
                <v-icon left> mdi-calendar-month </v-icon>
                {{ reserva.fechaFormated }}
              </v-chip>
              <v-chip outlined class="mx-2">
                <v-icon left> mdi-clock </v-icon>
                {{ reserva.hora }}
              </v-chip>
            </v-form>
          </v-card-text>
          <v-card-actions class="pt-5">
            <v-btn @click="cancelar()" color="error" text
              ><v-icon left>mdi-close</v-icon>Cancelar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn @click="enviarReserva" color="success" text
              ><v-icon left>mdi-check</v-icon>Reservar</v-btn
            >
          </v-card-actions>
        </div>
        <div v-else-if="done">
          <v-card-title class="justify-center success--text"
            >Turno reservado</v-card-title
          >

          <v-card-text>
            <div class="success-checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer
            ><v-btn
              text
              color="success"
              @click="
                done = false;
                reservaDialog = false;
                reserva = Object.assign({}, defaultReserva);
              "
              >Cerrar</v-btn
            >
          </v-card-actions>
        </div>
        <div v-else-if="fail">
          <v-card-title class="justify-center error--text"
            >Reserva fallida</v-card-title
          >
          <v-card-subtitle v-if="mensaje !== ''">{{ mensaje }}</v-card-subtitle>
          <v-card-text>
            <div>
              <svg
                class="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  class="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  class="checkmark__check"
                  fill="none"
                  d="M16 16 36 36 M36 16 16 36"
                />
              </svg>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer
            ><v-btn
              text
              color="error"
              @click="
                fail = false;
                reservaDialog = false;
                reserva = Object.assign({}, defaultReserva);
              "
              >Cerrar</v-btn
            >
          </v-card-actions>
        </div>
        <v-overlay :value="wait" absolute>
          <span>Procesando</span>
          <div>
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </div>
        </v-overlay>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapState, mapGetters, mapActions } from "vuex";
import TurnoService from "@/services/TurnoService";

export default {
  name: "Turnos",
  data: () => ({
    valid: true,
    isSubmit: false,
    autofocar: false,
    commonRules: [(v) => !!v || "Campo obligatorio"],
    pacientesPermitidos: [],
    reserva: {
      paciente: null,
      telefono: null,
      medico: null,
      hora: null,
      fechaFormated: null,
      idTurnoMedico: 0,
    },
    defaultReserva: {
      paciente: null,
      telefono: null,
      medico: null,
      hora: null,
      fechaFormated: null,
      idTurnoMedico: 0,
    },
    reservaDialog: false,
    done: false,
    fail: false,
    wait: false,
    mensaje: "",
  }),
  watch: {
    reservaDialog() {
      if (!this.reservaDialog) {
        this.done = false;
      }
    },
  },
  computed: {
    ...mapState("turnos", [
      "listaTurnos",
      "listaMedicos",
      "listaMisTurnos",
      "terminarOperacion",
    ]),
    ...mapState("parametro", ["listaPacientes"]),
    ...mapGetters("turnos", [
      "getTurnosByMedico",
      "getTurnosFiltrados",
      "getPacienteTelefono",
    ]),
    ...mapGetters("parametro", ["getPacienteTelefono"]),
  },
  methods: {
    ...mapActions("turnos", [
      "getListaTurnos",
      "reservarTurno",
      "setOperacionFlag",
    ]),
    selectTurno(turno) {
      this.reserva = Object.assign({}, turno);
      this.reservaDialog = true;
      this.pacientesPermitidos = [];

      if (this.$refs.form) this.$refs.form.resetValidation();

      // verificar cuales de los pacientes registrados pueden reservar el turno
      for (
        let pacienteIndex = 0;
        pacienteIndex < this.listaPacientes.length;
        pacienteIndex++
      ) {
        const paciente = this.listaPacientes[pacienteIndex];
        if (TurnoService.matchTurnoPaciente(turno, paciente)) {
          this.pacientesPermitidos.push(paciente);
        }
      }
      if (this.pacientesPermitidos.length === 1) {
        this.reserva.paciente = this.pacientesPermitidos[0];
        this.reserva.telefono = this.pacientesPermitidos[0].celular.replace(
          /[^0-9]/g,
          ""
        );
      } else {
        this.autofocar = true;
        setTimeout(() => {
          this.$refs.paciente.isMenuActive = true;
        }, 200);
      }
    },
    fillTelefono() {
      if (this.reserva.paciente) {
        this.reserva.telefono = this.reserva.paciente.celular.replace(
          /[^0-9]/g,
          ""
        );
      } else {
        this.reserva.telefono = null;
      }
    },
    cancelar() {
      this.reservaDialog = false;
      this.reserva = Object.assign({}, this.defaultReserva);
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    outsideClick() {
      if (this.wait) {
        return;
      } else {
        this.reserva = Object.assign({}, this.defaultReserva);
        if (!this.terminarOperacion) this.setOperacionFlag(null);
        if (this.$refs.form) this.$refs.form.resetValidation();
        this.reservaDialog = false;
        this.done = false;
        this.fail = false;
        this.wait = false;
        this.mensaje = "";
      }
    },
    delay(retryCount) {
      if (retryCount === 5) {
        return new Promise((resolve) => setTimeout(resolve, 10000));
      } else {
        return new Promise((resolve) => setTimeout(resolve, 10 ** retryCount));
      }
    },
    async getResource(retryCount = 0) {
      if (retryCount > 5 || this.terminarOperacion === false) {
        this.wait = false;
        this.fail = true;
        this.setOperacionFlag(null);
        return;
      }

      if (
        this.listaTurnos.find(
          (turno) => turno.idTurnoMedico === this.reserva.idTurnoMedico
        ) === undefined ||
        this.terminarOperacion === true
      ) {
        this.wait = false;
        this.done = true;
        this.setOperacionFlag(null);
        return;
      } else {
        await this.delay(retryCount);
        return this.getResource(retryCount + 1);
      }
    },
    async enviarReserva() {
      this.isSubmit = true;
      if (!this.$refs.form.validate()) {
        this.isSubmit = false;
        return;
      }

      try {
        this.wait = true;
        let check = this.listaTurnos.find(
          (turno) => turno.idTurnoMedico === this.reserva.idTurnoMedico
        );

        // check if turno is still in list, if not its not free anymore
        if (check === undefined || check === null) {
          this.wait = false;
          this.fail = true;
          this.mensaje = "¡Este turno ya fue reservado!";
        }

        if (this.fail === false) {
          // Sends reserva request to backend
          await this.reservarTurno({
            endpoint: "ReservarTurno",
            turno: this.reserva.idTurnoMedico,
            idPaciente: this.reserva.paciente.idPaciente,
            numeroNotificacion: this.reserva.telefono,
          });
          // Function to wait up to 10 seconds for 'ListaModificada' message
          await this.getResource();
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.reserva = Object.assign({}, this.defaultReserva);
        if (!this.terminarOperacion) this.setOperacionFlag(null);
        setTimeout(() => {
          if (this.$refs.form) this.$refs.form.resetValidation();
          this.reservaDialog = false;
          this.done = false;
          this.fail = false;
          this.wait = false;
          this.mensaje = "";
        }, 3000);
        this.isSubmit = false;
      }
    },
  },
};
</script>

<style scoped>
.fh-saved {
  border-style: solid;
  border-width: 1.5px;
  border-color: black;
}

.telfono a {
  text-decoration: none;
  color: black;
}
.telfono a:hover {
  color: #1a427f;
  text-decoration-line: underline;
}
/* Chrome, Safari, Edge, Opera */
.v-text-field >>> input::-webkit-outer-spin-button,
.v-text-field >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.v-text-field >>> input[type="number"] {
  -moz-appearance: textfield;
}
</style>
<style lang="scss" scoped>
/**
 * Extracted from: SweetAlert
 * Modified by: Istiak Tridip
 */
.success-checkmark {
  width: 80px;
  height: 115px;
  margin: 0 auto;

  .check-icon {
    width: 80px;
    height: 80px;
    position: relative;
    border-radius: 50%;
    box-sizing: content-box;
    border: 4px solid #4caf50;

    &::before {
      top: 3px;
      left: -2px;
      width: 30px;
      transform-origin: 100% 50%;
      border-radius: 100px 0 0 100px;
    }

    &::after {
      top: 0;
      left: 30px;
      width: 60px;
      transform-origin: 0 50%;
      border-radius: 0 100px 100px 0;
      animation: rotate-circle 4.25s ease-in;
    }

    &::before,
    &::after {
      content: "";
      height: 100px;
      position: absolute;
      background: #e8f5e9;
      transform: rotate(-45deg);
    }

    .icon-line {
      height: 5px;
      background-color: #4caf50;
      display: block;
      border-radius: 2px;
      position: absolute;
      z-index: 10;

      &.line-tip {
        top: 46px;
        left: 14px;
        width: 25px;
        transform: rotate(45deg);
        animation: icon-line-tip 0.75s;
      }

      &.line-long {
        top: 38px;
        right: 8px;
        width: 47px;
        transform: rotate(-45deg);
        animation: icon-line-long 0.75s;
      }
    }

    .icon-circle {
      top: -4px;
      left: -4px;
      z-index: 10;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      position: absolute;
      box-sizing: content-box;
      border: 4px solid rgba(76, 175, 80, 0.5);
    }

    .icon-fix {
      top: 8px;
      width: 5px;
      left: 26px;
      z-index: 1;
      height: 85px;
      position: absolute;
      transform: rotate(-45deg);
      background-color: #e8f5e9;
    }
  }
}

@keyframes rotate-circle {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}

@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}

@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}

.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: red;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}
.checkmark {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  margin: 10% auto;
  box-shadow: inset 0px 0px 0px red;
  animation: fill 0.4s ease-in-out 0.4s forwards,
    scale 0.3s ease-in-out 0.9s both;
}
.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 29;
  stroke-dashoffset: 29;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}
@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes scale {
  0%,
  100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px red;
  }
}
</style>
